import listActions from '../../../modules/taskTags/list/taskTagsListActions'
import TaskTagsService from '../../../modules/taskTags/taskTagsService'
import Errors from '../../../modules/shared/error/errors'
import { i18n } from '../../../i18n'
import { push } from 'redux-first-history'
import Message from '../../../view/shared/message'

const prefix = 'TASKTAGS_DESTROY'

const taskTagsDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: taskTagsDestroyActions.DESTROY_STARTED,
      })

      await TaskTagsService.destroyAll([id])

      dispatch({
        type: taskTagsDestroyActions.DESTROY_SUCCESS,
      })

      Message.success(
        i18n('entities.taskTags.destroy.success'),
      )

      dispatch(listActions.doFetchCurrentFilter())

      dispatch(push('/task-tags'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: taskTagsDestroyActions.DESTROY_ERROR,
      })
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: taskTagsDestroyActions.DESTROY_ALL_STARTED,
      })

      await TaskTagsService.destroyAll(ids)

      dispatch({
        type: taskTagsDestroyActions.DESTROY_ALL_SUCCESS,
      })

      if (listActions) {
        dispatch(listActions.doClearAllSelected())
        dispatch(listActions.doFetchCurrentFilter())
      }

      Message.success(
        i18n('entities.taskTags.destroyAll.success'),
      )

      dispatch(push('/task-tags'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: taskTagsDestroyActions.DESTROY_ALL_ERROR,
      })
    }
  },
}

export default taskTagsDestroyActions
